import api from 'Application/api/api';

const completeSingleInstructionAssignmentExam = (id, cancelToken = null) =>
    api.post(
        `/education/instruction-assignments/${id}/exam/complete/single`,
        {},
        {
            cancelToken,
        },
    );

export default completeSingleInstructionAssignmentExam;
